export class User {
    id: number;
    user: string;
    password: string;

    name: string;    
    image: string;
    role: string;
    token?: string; //PENDIENTE

    //DESDE EL SERVIDOR
    id_role: number;
    permissions: string[];

}